<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="d-flex flex-row justify-content-between">
        <div><h2 class="page-title">Truck List</h2></div>
        <div class="d-flex flex-row justify-content-end">
          <template v-if="user.type == 'ADMIN_MAINDEALER'">
            <div class="mr-3">
              <Multiselect
                :options="options.region"
                placeholder="All Region"
                v-model="filter.region"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <Multiselect
                :options="options.ekspedisi.map((x) => x.id)"
                :custom-label="
                  (opt) => options.ekspedisi.find((x) => x.id == opt).kode
                "
                placeholder="All Ekspedisi"
                v-model="filter.ekspedisi"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <button
                class="btn"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  width: 100%;
                  font-weight: bold;
                  margin: 0;
                "
                @click="modal.upload = true"
              >
                Upload File
              </button>
            </div>
            <div class="mr-3">
              <router-link
                to="/dashboard/create-truck"
                style="color: white; text-decoration: none"
              >
                <button
                  class="btn"
                  type="button"
                  style="
                    background-color: #f36f21;
                    color: white;
                    margin: 0;
                    width: 100%;
                    font-weight: bold;
                  "
                >
                  Create Truck
                </button>
              </router-link>
            </div>
          </template>
          <a href="" class="btn" style="    margin-right: -1rem !important;
    padding: 0;">
            <img src="@/assets/img/notification.svg" alt="" style="display: none;">
          </a>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="innerBox mt-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <input
              class="form-control filterInput col-lg-2"
              type="search"
              placeholder="Search by Nopol"
              aria-label="Search"
              v-model="filter.nopol"
              @click="vue_universal_table.update++"
              style="border-left: 0;"
            />
          </div>
          <vue-universal-table
            class="mt-3"
            api_url="/api/truck/list"
            :indexing="true"
            :filter="filter"
            :fields="vue_universal_table.fields"
            :update="vue_universal_table.update"
            :buttons="vue_universal_table.buttons"
            :table_striped="false"
            @onSeeDetails="onClick"
          ></vue-universal-table>
        </div>
      </div>
    </div>
    <!-- Chart End -->

    <!-- Modal Start -->
    <TruckUpload
      v-if="modal.upload"
      @closeModal="modal.upload = false"
      @onFinish="vue_universal_table.update++"
    />
    <!-- Modal End -->
  </div>
</template>

<script>
// import axios from 'axios';
import Multiselect from "vue-multiselect";
import debounce from "debounce";
import TruckUpload from "./children/TruckListUpload.vue";

export default {
  metaInfo: {
    title: "Truck List",
  },
  data() {
    let user = this.$store.getters.currentUser;

    let fields = [];

    if (user.type == "ADMIN_MAINDEALER") {
      fields = [
        { title: "Nopol", variable: "nopol", disable_sort: true },
        { title: "Ekspedisi", variable: "kode_ekspedisi", disable_sort: true },
        { title: "Tipe Truck", variable: "type_truck", disable_sort: true },
        { title: "Tanggal Efektif", variable: "startdate", disable_sort: true },
        {
          title: "Tanggal Non-Efektif",
          variable: "enddate",
          disable_sort: true,
        },
        { title: "Status Truck", variable: "status_truck", disable_sort: true },
      ];
    } else {
      fields = [
        { title: "Nopol", variable: "nopol", disable_sort: true },
        { title: "Tipe Truck", variable: "type_truck", disable_sort: true },
        { title: "Tanggal Efektif", variable: "startdate", disable_sort: true },
        {
          title: "Tanggal Non-Efektif",
          variable: "enddate",
          disable_sort: true,
        },
        { title: "Status Truck", variable: "status_truck", disable_sort: true },
      ];
    }
    return {
      user,
      apiData: [],
      modal: {
        upload: false,
      },
      selectedRegion: "",
      selectedEkspedisi: "",
      tableWidth: "100%",
      tableHeight: "100%",
      filter: {
        search: null,
        region: null,
        ekspedisi: null,
      },
      options: {
        region: this.$store.getters.getRegion,
        ekspedisi: this.$store.getters.getEkspedisi,
      },
      vue_universal_table: {
        fields: fields,
        buttons: [{ title: "seeDetails", class: "btn btn-secondary" }],
        filter: {},
        update: 0,
      },
    };
  },
  components: {
    Multiselect,
    TruckUpload,
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.debounceFunction();
      },
    },
  },
  methods: {
    onClick(truck) {
      this.$store.state.truckData = truck;
      this.$router.push({ path: "/dashboard/truck-list/detail" });
    },
    debounceFunction: debounce(function () {
      if (this.filter.region === 'All' || this.filter.ekspedisi === 999) {
        this.filter = {...this.filter, region: null, ekspedisi: null};
      }
      this.vue_universal_table.update++;
    }, 1500),
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}
</style>
